export default __webpack_public_path__ + "static/media/banner2.36460591.svg";